import { render, staticRenderFns } from "./_addressModal.vue?vue&type=template&id=8870b82a&"
import script from "./_addressModal.vue?vue&type=script&lang=js&"
export * from "./_addressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports